var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnpaid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7511 27.8163C3.79502 27.8163 2.00195 29.2749 2.00195 31.0576V24.5313C2.00195 22.7486 3.79502 21.29 5.7511 21.29C7.87018 21.29 9.50025 22.7486 9.50025 24.5313C9.50025 22.7486 11.2933 21.29 13.2494 21.29C15.3685 21.29 16.9985 22.7486 16.9985 24.5313C16.9985 22.7486 18.6286 21.29 20.7477 21.29C23.1928 21.29 24.8228 22.7486 24.8228 24.5313V31.0576C24.8228 29.2749 23.1928 27.8163 20.7477 27.8163C18.6286 27.8163 16.9985 29.2749 16.9985 31.0576C16.9985 29.2749 15.3685 27.8163 13.2494 27.8163C11.2933 27.8163 9.50025 29.2749 9.50025 31.0576C9.50025 29.2749 7.87018 27.8163 5.7511 27.8163Z",
    fill: "#FC9C9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8228 31.0597V5.12989C24.8228 3.34722 23.3558 1.88867 21.5627 1.88867H5.26208C3.46901 1.88867 2.00195 3.34722 2.00195 5.12989V31.0597C2.00195 29.277 3.79502 27.8184 5.7511 27.8184C7.87018 27.8184 9.50025 29.277 9.50025 31.0597C9.50025 29.277 11.2933 27.8184 13.2494 27.8184C15.3685 27.8184 16.9985 29.277 16.9985 31.0597C16.9985 29.277 18.6286 27.8184 20.7477 27.8184C23.1928 27.8184 24.8228 29.277 24.8228 31.0597Z",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52344 14.8525H18.3038",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52344 8.37109H18.3038",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0571 24.5554C18.0571 28.2067 21.017 31.1666 24.6682 31.1666C26.5254 31.1666 28.2037 30.4008 29.4046 29.1677C30.5647 27.9766 31.2793 26.3495 31.2793 24.5554C31.2793 20.9042 28.3194 17.9443 24.6682 17.9443C22.8553 17.9443 21.2129 18.674 20.0185 19.8557C18.8074 21.054 18.0571 22.7171 18.0571 24.5554Z",
    fill: "white",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.668 21.4893V24.3472",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.668 27.2021H24.6772",
    stroke: "#383434",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpaid);
export default __webpack_public_path__ + "static/media/Unpaid.9e6578865979626beb729ade9e61e3c9.svg";
export { ForwardRef as ReactComponent };